const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      work: 'Work With Me',
      events: 'Events',
      zoom: "Zoom Maestra",
      contact: 'Contact',
    },
        home: {
      welcome: 'Welcome',
      seoIntroTiha:
        'Tiha Psiha is a space for psychology, facilitation, individual sessions, workshops, and symbolic experiential work.',
      seoIntroZoom:
        'Zoom Maestra offers online event support, Zoom support, and hybrid event coordination for facilitators, therapists, educators, and group leaders.',

      tagline: 'Not a new self. A different relationship to the same self.',
      intro:
        'Tiha Psiha is not a place where someone comes to be fixed. It is a space where inner life becomes safe enough to appear. Here, we do not rush toward an answer. We slow down enough for what is unclear, held back, quiet, or still without form to become visible.',

      howIWork: 'How I Work',
      workDescription:
        'My work integrates psychology, process facilitation, embodied practices, and symbolic awareness to create spaces where transformation can unfold naturally.',

      pillar1Title: 'Individual Sessions',
      pillar1Desc:
        'One-on-one work for personal transition, self-discovery, and finding clarity in moments of change.',
      pillar2Title: 'Group Processes',
      pillar2Desc:
        'Experiential workshops and group facilitation, including Soul Theater and transformational group work.',
      pillar3Title: 'Immersive Sound Experiences',
      pillar3Desc:
        'Spaces combining sound, ritual elements, and embodied awareness for deeper integration.',

      pillar1Question:
        'Do you feel stuck in old patterns? Are you seeking clarity in a moment of change?',
      pillar2Question:
        'Is your community or team going through transformation? Are you looking for a space for collective exploration?',
      pillar3Question:
        'Do you feel that words are not enough? Are you seeking a deeper language — through body, sound, and symbol?',

      offerings: 'Offerings',
      offering1: 'Individual Sessions',
      offering1Sub: 'Private transformational work',
      offering2: 'Group Workshops',
      offering2Sub: 'Experiential collective processes',
      offering3: 'Immersive Sound Experiences',
      offering3Sub: 'Immersive embodied journeys',
      offering4: 'Custom Facilitation',
      offering4Sub: 'Tailored processes for organizations',

      ready: 'When something in you is ready to be heard',
      inviteText:
        'You do not need to know exactly what you need before reaching out. It is enough to sense that something in you is asking for attention, space, and a more truthful relationship.',
      cta: 'Write to me',

      subline: 'Individual work, group exploration, and sound-based experiences.',
      toolsTitle: 'Sound & Symbolic Tools',
      toolsText:
        'My practice incorporates instruments and symbolic objects that support the journey of transformation. Sound bowls, drums, and ritual elements create spaces where deeper awareness can emerge.',

      zoomTitle: 'For Facilitators',
      zoomText:
        'Zoom Maestra supports facilitators, educators, and therapists who want to work online with more ease, less technical stress, and a stronger sense of flow.',
      zoomButton: 'Explore Zoom Maestra',

      recognitionLabel: 'You may be here because...',
      recognitionItems: [
        {
          title: 'You are standing at an inner threshold',
          text: 'and the old way of functioning no longer feels true.',
        },
        {
          title: 'You have been holding too much for too long',
          text: 'without enough space to pause, feel, and listen.',
        },
        {
          title: 'You are looking for a different relationship with yourself',
          text: 'not another attempt to fix who you are.',
        },
        {
          title: 'You want a space where you do not have to know immediately',
          text: 'what comes next.',
        },
        {
          title: 'You feel that something inside you is asking for form',
          text: 'a word, a gesture, a boundary, a voice, a path, or a more truthful place in your life.',
        },
      ],

      encounterLabel: 'At the threshold',
      encounterTitle1: 'Not a new self.',
      encounterTitle2: 'A different relationship to the same self.',
      encounterBlock1Title:
        'Some experiences become clearer only when there is enough safety to meet them.',
      encounterBlock1Text:
        'Not only through conversation, but through relationship, action, body, symbol, silence, and the presence of another person or group.',
      encounterBlock2Title:
        'Experience does not have to be explained immediately to be real.',
      encounterBlock2Text:
        'In this work, we pay attention to what forms between impulse, action, inner life, body, image, and relationship with others.',
      encounterBlock3Title:
        'Sometimes a person first notices their own truth when it is given space, voice, movement, or form.',

      methodLabel: 'How we work in this space',
      methodTitle: 'Conversation, body, symbol, action and silence.',
      methodIntro:
        'The work in Tiha Psiha brings together psychological reflection, experiential methods, symbolic exploration, body awareness, movement, role, group process, and careful attention to what is actually present.',

      method1Title: 'Psychology',
      method1Text:
        'Inner life is not treated as a problem to be fixed quickly, but as a space that can slowly become more readable.',
      method2Title: 'Action-based methods',
      method2Text:
        'Some experiences become clearer only when we see them, enact them, place them in space, or meet them from another perspective.',
      method3Title: 'Body and movement',
      method3Text:
        'The body often registers truth, tension, fear, longing, and change before the mind can explain them.',
      method4Title: 'Symbolic work',
      method4Text:
        'Images, roles, metaphors, dreams and inner scenes sometimes carry more information than explanation.',
      method5Title: 'Group process',
      method5Text:
        'Relationship with others can become the place where we first notice our patterns, impulses, boundaries, and possibilities for something new.',

      spacesLabel: 'Paths through the garden',
      spacesTitle: 'Different ways of entering the work.',
      space1Title: 'Individual sessions',
      space1Text1:
        'One-on-one work through conversation, symbol, body awareness and experiential exploration.',
      space1Text2:
        'For periods of transition, overwhelm, inner conflict, decision-making, grief, longing, or the need for clearer contact with yourself.',
      space2Title: 'Workshops and group spaces',
      space2Text:
        'Online and in-person spaces where inner experience becomes visible through encounter, action, role, group process and symbolic work.',
      space3Title: 'The Practice of Silence',
      space3Text:
        'An exploration of attention, stimulation, the nervous system and the relationship to inner rhythm through writing, practice and experiential process.',

      credibility:
        "Master's degree in Psychology • 15+ years of group work experience • psychodrama-informed practice • physical theatre • Tele'Drama • international online and in-person processes",

      silenceLabel: 'The Practice of Silence',
      silenceTitle: 'A quiet path for attention, rhythm and the nervous system.',
      silenceText:
        'A real-time exploration of silence, attention and preparation for ten days of silence — documented through field notes, embodiment and psychological observation.',
      silenceBlockButton: 'Enter the practice',
    },
   about: {
  eyebrow: 'About',
  heroTitle: 'I hold spaces where inner life can become visible without being forced.',
  heroIntro:
    'My name is Tihomira Stanojević. I am a psychologist, facilitator and experiential practitioner. Tiha Psiha grew from psychology, group work, psychodrama-informed methods, body-based and symbolic exploration, sound, online spaces, and years of learning how people begin to appear more truthfully when they no longer have to be fixed.',
  heroIntro2:
    'I work with experience as it actually appears — through words, silence, body, image, role, rhythm, relationship and the small signals that often arrive before a clear explanation.',
  identityLabel: 'Who holds the space',
  identityTitle: 'Psychologist, facilitator, practitioner of experiential work.',
  identityText:
    'I hold a master’s degree in psychology and have more than fifteen years of experience with groups, experiential learning and action-based methods. My work has been shaped by psychodrama, Psychodramatic Bodywork®, physical theatre, Tele’Drama, symbolic process, online facilitation and sound-based spaces.',
  identityNote:
    'I name my background honestly: psychodrama and related experiential methods deeply inform my work, while Tiha Psiha is not presented as psychotherapy or as a certified psychodrama practice.',
  foundationsLabel: 'What shapes the work',
  foundationsTitle: 'A grounded space for experience, symbol and relationship.',
  foundationsIntro:
    'The work often begins with words, but it does not stay only in words. Sometimes the body knows before the mind can explain. Sometimes an image, role, movement or relationship shows what a sentence cannot yet hold.',
  foundation1Title: 'Psychology',
  foundation1Text:
    'Psychology gives the work a grounded frame: attention to inner life, patterns, relationships, development, boundaries, emotions and the complexity of human experience.',
  foundation2Title: 'Group process',
  foundation2Text:
    'Groups can reveal what remains hidden in isolation. Through witnessing, resonance and encounter, people often begin to see their own impulses, limits and possibilities more clearly.',
  foundation3Title: 'Body, sound and symbol',
  foundation3Text:
    'Some experiences do not become clear through explanation alone. Movement, image, rhythm, sound and symbolic action can give form to what has been quiet, blurred or difficult to name.',
  foundation4Title: 'Crossings and online spaces',
  foundation4Text:
    'Living across cultures and working with international online groups taught me to listen for belonging, dislocation, transition and the subtle ways people search for safety and presence.',
  trainingLabel: 'Training and experience',
  trainingTitle: 'Formal grounding, clearly named.',
  trainingIntro:
    'The space is soft, but it is not vague. It is held by formal psychological education, long-term experiential training and years of work with groups, online processes and embodied practice.',
  trainingItem1:
    'Undergraduate and master studies in psychology at the University of Novi Sad.',
  trainingItem2:
    'Four years of classical psychodrama training in Novi Sad.',
  trainingItem3:
    'Advanced Level Psychodramatic Bodywork® training process with Susan Aaron.',
  trainingItem4:
    'Multiple cycles of Physical Theatre training with director Marija Farmer, including devising, Complicité-informed work, embodiment and symbolic action.',
  trainingItem5:
    'Additional learning through Transactional Analysis, Tele’Drama Practitioner trainings, Ericksonian approaches, conversational hypnosis and Ethics — Path to the True Self training.',
  trainingItem6:
    'More than fifteen years of work with groups in educational, psychodramatic, creative, ecological, online and hybrid contexts.',
  experienceLabel: 'Lived experience',
  experienceTitle: 'The work was shaped through thresholds.',
  experienceText:
    'I have lived and worked across different cultural contexts, including Serbia, China, Ecuador, India, Malta, Slovenia, Russia and Spain. These crossings changed how I understand transition, belonging, identity, loss of familiar ground and the body’s need for safety.',
  experienceText2:
    'Sound entered gradually, through instruments gathered in different places and through the need to listen beyond language. It became part of the way I work with attention, rhythm, atmosphere and embodied presence.',
  storyLabel: 'A shorter story',
  storyTitle: 'Not a linear path.',
  storyIntro:
    'The longer personal story belongs to another space. Here, I keep only the threads that directly shape the way I hold Tiha Psiha.',
  story1Title: 'Listening before speaking',
  story1Text:
    'Volunteering at Centar Srce in Novi Sad taught me the discipline of listening before interpretation, advice or direction. It shaped my respect for what appears when someone is not interrupted.',
  story2Title: 'Online space became real space',
  story2Text:
    'Through Tele’Drama and international online groups, I learned that online work can hold presence, action, intimacy and group process when the structure is clear and the attention is real.',
  story3Title: 'Crossroads became practice',
  story3Text:
    'Relocations, returns, uncertainty and reinvention taught me that transition is not something to rush through. It is a threshold that asks for attention, patience and a different relationship to oneself.',
  ctaWork: 'Work with me',
  ctaContact: 'Get in touch',
  closingQuote:
    'I do not lead people to destinations. I help them listen for the path that is already beginning to form.',
  closingButton: 'Explore ways of working',
},
    work: {
      eyebrow: 'Work With Me',
      title: 'Psychology-informed support for moments of transition, uncertainty and inner change.',
      intro: 'Tiha Psiha is a psychology-informed practice in development, offering individual sessions, small experiential workshops and in-person sound experiences for people moving through transition, uncertainty or inner change.',
      intro2: 'The work is grounded in psychology, experiential methods, symbolic exploration and careful attention to what is actually present now.',
      heroBadge1: 'Currently available',
      heroBadge2: 'By invitation',
      heroBadge3: 'In development',
      availableLabel: 'Currently available',
      availableTitle: 'You can start here.',
      availableIntro: 'These are the formats currently available online. They are simple, focused and designed for people who want a grounded space for reflection, insight and inner orientation.',
      orientationTitle: 'Free Orientation Call',
      orientationMeta: '15 minutes · Online',
      orientationText: 'A short conversation to see what you are looking for, whether this work is a good fit, and which format would serve you best.',
      orientationPrice: 'Free',
      orientationCta: 'Book an orientation call',
      orientationMessage: 'I am interested in a free orientation call. I would like to briefly share what brings me here...',
      dreamTitle: 'Guided Dream Exploration Session',
      dreamMeta: 'Up to 60 minutes · Online',
      dreamText: 'A guided interview with a dream, symbol or inner image. This is not classical dream interpretation. The process is connected with Joseph Dillard’s Integral Deep Listening / dream interview approach, for which I was personally trained by Joseph Dillard. The aim is practical insight, inner answers and a clearer view of the situation you are in.',
      dreamPrice: '50 EUR',
      buyForMyself: 'Buy for myself',
      buyAsGift: 'Buy as a gift',
      dreamMessage: 'I am interested in buying a Guided Dream Exploration Session for myself.',
      dreamGiftMessage: 'I am interested in buying a Guided Dream Exploration Session as a gift.',
      packageTitle: 'Individual Support Packages',
      packageMeta: 'Online · One-to-one',
      packageText: 'Individual sessions for people who are moving through transition, inner conflict, uncertainty or a need for clearer contact with themselves. The work may include conversation, symbolic exploration, body awareness and experiential reflection.',
      packagePrice: 'From 50 EUR',
      packageCta: 'Ask about individual support',
      packageMessage: 'I am interested in individual support packages. I would like to share what kind of process I am looking for...',
      pricingLabel: 'Prices',
      pricingTitle: 'Sessions and packages',
      pricingIntro: 'Packages are intended for reflective and developmental work. They are not intended for crisis situations.',
      singleSessionTitle: '1 session',
      singleSessionPrice: '50 EUR',
      singleSessionValidity: 'A single session is valid for 3 months from the date of purchase.',
      threeSessionsTitle: '3 sessions',
      threeSessionsPrice: '130 EUR',
      threeSessionsValidity: '3-session package is valid for 2 months from the date of purchase.',
      fiveSessionsTitle: '5 sessions',
      fiveSessionsPrice: '200 EUR',
      fiveSessionsValidity: '5-session package is valid for 3 months from the date of purchase.',
      giftSessionTitle: 'Gift session',
      giftSessionPrice: '50 EUR',
      giftSessionValidity: 'Gift session is valid for 3 months from the date of purchase.',
      termsNotice: 'By purchasing a session or package, you agree to the scheduling, rescheduling and cancellation terms.',
      termsLink: 'Read terms',
      invitationLabel: 'By invitation',
      invitationTitle: 'Workshops, group processes and sound experiences.',
      invitationIntro: 'Some formats are offered through collaboration, invitation or local organization. They can be shaped around a group, city, community or specific theme.',
      invite1Title: 'Workshops & Group Processes',
      invite1Text: 'Small online or in-person spaces for experiential exploration through encounter, action, symbol, role, group presence and what forms between people.',
      invite2Title: 'In-Person Sound Experiences',
      invite2Text: 'Sound-based gatherings are offered in person, depending on location, collaboration and available space. They are not performances, but carefully held experiential spaces.',
      invitationCta: 'Invite or host a format',
      invitationMessage: 'I am interested in hosting or inviting a workshop, group process or sound experience. Here is what I have in mind...',
      developmentLabel: 'In development',
      developmentTitle: 'What is still taking shape.',
      developmentIntro: 'Tiha Psiha is intentionally developing step by step. Some formats are being shaped slowly, with care, so they can become clear, useful and sustainable.',
      development1Title: 'Small ongoing groups',
      development1Text: 'Ongoing online groups may open later for people who want continuity, shared reflection and experiential exploration over time.',
      development2Title: 'Recorded sound experiences',
      development2Text: 'Recorded sound-based materials are in development as a future digital offer. They will be created carefully, with clear framing and simple access.',
      questionsTitle: 'Not sure where to begin?',
      questionsText:'You do not need to know the exact format before reaching out. A short orientation conversation is often enough to clarify the next step.',
      reach: 'Get in touch',
      finalMessage:'I am interested in working with you, but I am not sure which format is the best fit yet.',
    },
events: {
  label: 'Gatherings & Events',
  heroTitle:
    'Spaces where experience becomes visible through encounter, action, and group work.',
  heroIntro:
    'Events at Tiha Psiha are not designed as performances, lectures, or quick solutions. They are spaces for experiential exploration — through relationship, action, symbol, role, group presence, and what forms between people.',
  currentTitle: 'Current exploration',
  event1Type: 'Online experiential workshop',
  event1Title: 'AI & Human Encounter',
  event1RealTitle: 'How do I actually feel about AI?',
  event1Para1:
  'Lately, we speak more and more often about artificial intelligence — but less often about what happens inside us when we think about it.',
  event1Para2:
  'This workshop is not about what AI is, but about what is activated in us when we encounter it.',
  event1Para3:
  'Do I feel relief or pressure? Does it support me or speed me up beyond my own rhythm? What happens to my creativity, my way of working and my sense of value?',
  event1Para4:
  'Through work in a small group and with the help of psychodramatic and action-based methods, we will explore the inner reactions, questions and voices that appear in the encounter with AI — without needing to take the “right” position.',
  eventDateLabel: 'Date:',
eventDateValue: '04.06.2026, Thursday',

eventTimeLabel: 'Time:',
eventTimeValue: '18:00–21:00',

eventFormatLabel: 'Format:',
eventFormatValue: 'online / Zoom',

eventLanguageLabel: 'Language:',
eventLanguageValue: 'Serbian / Croatian',

eventPriceLabel: 'Price:',
eventPriceValue: '1000 RSD / 10 EUR',

eventGroupLabel: 'Group:',
eventGroupValue: 'up to 15 participants',
  event1Text:
    'An experiential exploration of the relationship between humans and artificial intelligence through psychodramatic and action-based methods.',
  event1Button: 'Ask about this workshop',
  inquiryTitle: 'Ongoing themes',
  inquiryText:
    'Current themes of exploration include attention, AI and human relationship, group encounter, embodiment, impulse, overstimulation, symbolic process, and relational dynamics.',

  formTitle: 'Registration',
  formNameLabel: 'Full name',
  formEmailLabel: 'Email',
  formLocationLabel: 'Where are you joining from?',
  formMessageLabel: 'What interests you most about this topic right now?',
  formNote: 'After registering, you will receive an email with confirmation and payment information.',
  formButton: 'Send registration',
  formSuccessTitle: 'Thank you, your registration has been sent.',
  formSuccessText: 'I will get back to you soon with confirmation.',
  eventHiddenValue: 'How do I actually feel about AI? — 04.06.2026',

  upcomingTitle: 'Coming up',
  upcomingType: 'Exploration',
  upcomingItems: [
    {
      title: 'Warming up for new roles',
      subtitle: 'When the old identity no longer fits, and the new one is not yet alive.',
    },
    {
      title: 'Stuck in change',
      subtitle: 'When the past holds on, and the future is calling.',
    },
    {
      title: 'Who in us protests',
      subtitle: 'Illuminating the inner saboteur.',
    },
  ],

  ongoingGroupsTitle: 'Ongoing groups',
  ongoingGroupsText1:
    'Weekly online group meetings for people who want continuity in working with themselves and others.',
  ongoingGroupsText2:
    'Small online group spaces for continuous experiential exploration through encounter, relationship, action and group dynamics.',

  themesTitle: 'Themes I explore',
  themesText:
    'Current themes of exploration include attention, the relationship between humans and AI, group encounter, body, impulse, overwhelm, symbolic process and relational dynamics.',
},
    zoom: {
  title: 'Zoom Maestra',
      eyebrow: 'Supporting the invisible architecture of online events',
      intro: 'Zoom Maestra supports the invisible architecture of online events, helping facilitators, educators, and therapists deliver their work with clarity, stability, and ease.',
      lead1: 'Many people who hold powerful workshops, courses, and group processes online find themselves overwhelmed by the technical side of hosting.',
      lead2: 'Instead of focusing on participants and the process, they end up managing breakout rooms, registrations, screen sharing, and unexpected technical issues.',
      lead3: 'Zoom Maestra exists so that facilitators can remain present with their people — while the structure of the event is quietly supported in the background.',
      audienceTitle: 'Who this is for',
      audienceText: 'Zoom Maestra supports professionals who work with people online and want a smoother, calmer technical environment.',
      audienceList1: 'facilitators and group leaders',
      audienceList2: 'therapists and coaches',
      audienceList3: 'educators and course creators',
      audienceList4: 'retreat hosts moving programs online',
      audienceList5: 'organizations running online workshops or trainings',
      audienceClosing: 'If your work involves holding space for people, the technical layer should support that space — not disrupt it.',
      supportTitle: 'How Zoom Maestra supports your event',
      supportIntro: 'Support can include:',
      supportBlock1Title: 'Event structure and preparation',
      supportBlock1Item1: 'designing the Zoom session flow',
      supportBlock1Item2: 'preparing breakout rooms and group structures',
      supportBlock1Item3: 'creating a clear technical plan for the event',
      supportBlock2Title: 'Registration and participant flow',
      supportBlock2Item1: 'helping organize registration systems',
      supportBlock2Item2: 'preparing communication with participants',
      supportBlock2Item3: 'creating a smooth entry process for events',
      supportBlock3Title: 'Live event hosting',
      supportBlock3Item1: 'technical hosting during the event',
      supportBlock3Item2: 'managing breakout rooms and transitions',
      supportBlock3Item3: 'screen sharing and technical troubleshooting',
      supportBlock4Title: 'Hybrid and complex events',
      supportBlock4Item1: 'support for events combining online and physical spaces',
      supportBlock4Item2: 'coordination between facilitators and technical layers',
      supportClosing: 'The goal is simple: to create a stable structure where facilitators can focus on people and process.',
      packagesTitle: 'Ways we can work together',
      package1Title: 'Session Support',
      package1Text: 'For facilitators who need calm technical support during a single online session.',
      package1Item1: 'Zoom room setup',
      package1Item2: 'breakout room management',
      package1Item3: 'screen sharing support',
      package1Item4: 'participant entry and transitions',
      package1Item5: 'basic troubleshooting during the event',
      package1Ideal: 'Ideal for single workshops, group sessions, guest lectures, and online classes.',
      package2Title: 'Workshop Support',
      package2Text: 'For facilitators running longer workshops or multi-session programs who want a smoother structure and participant experience.',
      package2Item1: 'preparation call before the event',
      package2Item2: 'event flow planning',
      package2Item3: 'Zoom technical setup',
      package2Item4: 'participant entry management',
      package2Item5: 'breakout rooms and transitions',
      package2Item6: 'technical hosting during the event',
      package2Ideal: 'Ideal for half-day or full-day workshops, courses, and multi-session programs.',
      package3Title: 'Program Support',
      package3Text: 'For complex online or hybrid events where facilitators want full technical structure behind the process.',
      package3Item1: 'event architecture planning',
      package3Item2: 'registration flow support',
      package3Item3: 'participant communication setup',
      package3Item4: 'Zoom event hosting',
      package3Item5: 'breakout room coordination',
      package3Item6: 'technical presence throughout the event',
      package3Ideal: 'Ideal for online retreats, conferences, longer programs, and hybrid events.',
      whyTitle: 'Why facilitators work with Zoom Maestra',
      whyIntro: 'When facilitators hold online spaces, their attention is meant to be with the people in the room — not with the technology.',
      whyIntro2: 'Zoom Maestra supports the technical and structural layer of the event so that facilitators can remain fully present in their role.',
      why1Title: 'Presence with participants',
      why1Text: 'When the technical side of an event is supported, facilitators can focus entirely on the people they are working with — listening, guiding, and responding to the process in real time.',
      why2Title: 'A calmer event flow',
      why2Text: 'Online events often become stressful when the structure is unclear. With clear preparation and technical support, transitions become smoother and the experience feels more grounded for both facilitators and participants.',
      why3Title: 'Reliability and stability',
      why3Text: 'Unexpected technical situations can interrupt the atmosphere of a workshop. Having someone quietly holding the technical side creates a sense of stability for the entire group.',
      why4Title: 'Space for deeper work',
      why4Text: 'When facilitators do not need to manage technical details, they have more energy to focus on what matters most — the process, the group dynamic, and the transformation that can emerge in the space.',
      ctaTitle: 'Need calm, reliable support for your online event?',
      ctaText: 'If you are preparing an online workshop, course, training, or group process and want the technology to support the experience rather than interrupt it, I would be happy to hear about your project.',
      ctaText2: 'Every event is different, and we can explore what kind of structure and support would serve it best.',
      ctaButton: 'Ask About Zoom Maestra',
      testimonialsLabel: 'What people say',
      testimonialsTitle: 'In their own words',
      testimonial1Name: 'Diane Adderley',
      testimonial1Text: 'I feel safe and confident when Tina is at the technical helm of our workshops. I know she will do a good job, and I do not have to worry about anything going wrong. If something unexpected did happen, I am sure she would handle it with her usual calm. I would strongly recommend her services.',
      testimonial1Role:  'Honorary President and Senior Sociodrama Trainer, British Psychodrama Association; Guest Faculty, Tele’Drama International.',
      testimonial2Name: 'Marija Babić',
      testimonial2Text: 'I have been collaborating with Tina on various projects for a long time. Whenever I know she is taking care of the space and the technical details on Zoom, I have not the slightest worry or doubt about how the event will unfold and conclude.',
      testimonial2Role: 'PermaVEZ Collective',
      testimonial3Name: 'Lou Van Laake',
      testimonial3Text: 'Having Tina as my tech support allowed me to fully focus on my task as host and facilitator. Her calm and capable presence behind the scenes took away a layer of added responsibility and stress, and helped me stay fully present with the people on screen. I remember feeling calmer myself, more able to breathe, and with more headspace to deal with whatever was coming up in the meeting itself. Especially for creative online work, such as Playback Theatre or Psychodrama, I would highly recommend Tina. She understands these art forms in this still-new online platform — knowing the right moments to spotlight, mute, or move people to “sit” next to the facilitator. Tina brings knowledge, creativity, curiosity, and a calm willingness to fix, explain, and support the people she works with. She is silently present, but unmissable. She is also clear in asking questions and giving feedback, and is simply a dream to work with.',
      testimonial3Role: 'Playback Theatre facilitator, physical theatre practitioner, and leader of Full Circle Playback Theatre, Dublin, Ireland.',
      testimonial4Name: 'Dr. Ron Wiener',
      testimonial4Text: 'Tina Stanojević was the excellent tech support at a sociodrama workshop I recently co-facilitated on Zoom. She took part in the planning and made useful suggestions both before and during the workshop. In the session itself, she used her technical skills to ensure that everything flowed smoothly, including setting up a clock for the break periods, which enabled everyone to return on time.',
      testimonial4Role: 'Senior Sociodrama Trainer.',    },
    contact: {
      title: 'Get in Touch',
      intro: "Whether you're seeking individual sessions, interested in group work, or curious about what's possible, I'm here to listen and support your journey.",
      email: 'Email',
      follow: 'Follow',
      response: 'I typically respond to inquiries within 2–3 days. Thank you for reaching out.',
      yourName: 'Your Name',
      namePlaceholder: 'Your name',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      message: 'Message',
      messagePlaceholder: 'Tell me about what brings you here...',
      send: 'Send Message',
      successMessage: '✓ Message has been sent!',
      errorMessage: 'Something went wrong. Please try again or email me directly.',
      sending: 'Sending...',
      formSubject: 'Message from',
      formName: 'Name',
      formEmail: 'Email',
      contactFlowTitle: 'How can I support you?',
      contactFlowIntro: 'Choose the path that best fits what you are looking for.',
      path1Title: 'Individual Work',
      path1Text: 'For people seeking one-to-one transformational support.',
      path1Button: 'Ask About Individual Work',
      path1Subject: 'Individual Work Inquiry',
      path2Title: 'Workshops & Group Processes',
      path2Text: 'For organizers, communities, teams, and group collaborations.',
      path2Button: 'Ask About Workshops',
      path2Subject: 'Workshop / Group Inquiry',
      path3Title: 'In-Person Sound Experiences',
      path3Text: 'For yoga studios, retreat spaces, small groups and organizers who want a carefully held sound-based space.',
      path3Button: 'Ask about a sound experience',
      path3Subject: 'Sound Experience Inquiry',
      path3LearnMore: 'Learn more',
      path1Message: 'I am interested in individual work. I would like to share a little about what brings me here...',
      path2Message: 'I am interested in a workshop, group process or sound bath. Here is what I have in mind...',
      path3Message: 'I am interested in an in-person sound experience / sound bath. I would like to share where it would take place, for how many people, and what kind of space I have in mind...',
    },
     footer: {
      brand: 'Tiha Psiha',
      tagline:'Psychology, embodiment and experiential spaces for people in transition.',
      credentials: "Master's degree in Psychology • psychodrama • embodiment • international online and in-person work",
      zoomText: 'Support for online group spaces, workshops and facilitators.',
      copyright: 'All rights reserved.',
      desc: 'Transformational facilitation and psychology',
      rights: '© 2024 Tihomira Stanojević. All rights reserved.',
    },
  },

  sr: {
    nav: {
      home: 'Početak',
      about: 'O meni',
      work: 'Rad sa mnom',
      events: 'Događaji',
      zoom: 'Zoom Maestra',
      contact: 'Kontakt',
    },
        home: {
      welcome: 'Dobrodošli',
      seoIntroTiha:
        'Tiha Psiha je prostor za psihologiju, facilitaciju, individualne susrete, radionice i simbolički iskustveni rad.',
      seoIntroZoom:
        'Zoom Maestra pruža online event support, Zoom podršku i koordinaciju hibridnih događaja za facilitatore, terapeute, edukatore i voditelje grupa.',

      tagline: 'Ne novo ja. Drugačiji odnos prema istom ja.',
      intro:
        'Tiha Psiha nije mesto gde neko dolazi da bude popravljen. To je prostor u kome unutrašnji život postaje dovoljno bezbedan da se pokaže. Ovde se ne žuri ka odgovoru. Usporavamo dovoljno da ono što je mutno, zadržano, tiho ili još bez oblika može da postane vidljivo.',

      howIWork: 'Kako radim',
      workDescription:
        'Moj rad integriše psihologiju, facilitaciju procesa, telesne prakse i simboličku svesnost kako bi se stvorio prostor u kome transformacija može prirodno da se odvija.',

      pillar1Title: 'Individualne sesije',
      pillar1Desc:
        'Rad jedan na jedan za lične prelaze, samootkrivanje i pronalaženje jasnoće u trenucima promene.',
      pillar2Title: 'Grupni procesi',
      pillar2Desc:
        'Iskustvene radionice i grupna facilitacija, uključujući Soul Theater i transformativni grupni rad.',
      pillar3Title: 'Zvučna iskustva uživo',
      pillar3Desc:
        'Prostori koji spajaju zvuk, ritualne elemente i telesnu svesnost radi dublje integracije.',

      pillar1Question:
        'Da li osećaš da si zaglavljen/a u starim obrascima? Tražiš li jasnoću u trenutku promene?',
      pillar2Question:
        'Da li tvoja zajednica ili tim prolazi kroz transformaciju? Tražiš li prostor za kolektivno istraživanje?',
      pillar3Question:
        'Da li osećaš da reči nisu dovoljne? Tražiš li dublji jezik — kroz telo, zvuk i simbol?',

      offerings: 'Ponuda',
      offering1: 'Individualne sesije',
      offering1Sub: 'Privatan transformativni rad',
      offering2: 'Grupne radionice',
      offering2Sub: 'Iskustveni kolektivni procesi',
      offering3: 'Zvučna iskustva uživo',
      offering3Sub: 'Imerzivna telesna putovanja',
      offering4: 'Prilagođena facilitacija',
      offering4Sub: 'Procesi prilagođeni organizacijama',

      ready: 'Kada je nešto u tebi spremno da bude saslušano',
      inviteText:
        'Ne moraš unapred da znaš tačno šta ti treba. Dovoljno je da postoji osećaj da nešto u tebi traži pažnju, prostor i istinitiji odnos.',
      cta: 'Piši mi',

      subline: 'Individualni rad, grupno istraživanje i zvučna iskustva.',
      toolsTitle: 'Zvučni i simbolički alati',
      toolsText:
        'U svom radu koristim instrumente i simboličke objekte koji podržavaju proces transformacije. Zvučne činije, bubnjevi i ritualni elementi stvaraju prostor u kome može da se pojavi dublja svesnost.',

      zoomTitle: 'Za voditelje grupa',
      zoomText:
        'Zoom Maestra podržava facilitatore, edukatore i terapeute koji žele da rade online sa više lakoće, manje tehničkog stresa i više osećaja toka.',
      zoomButton: 'Istraži Zoom Maestru',
      ctaSubject: 'Upit za Zoom Maestru',

      recognitionLabel: 'Možda ste ovde jer...',
      recognitionItems: [
        {
          title: 'Nalazite se na unutrašnjem pragu',
          text: 'i stari način funkcionisanja više ne deluje istinito.',
        },
        {
          title: 'Osećate da držite previše toga predugo',
          text: 'bez dovoljno prostora da stanete, osetite i čujete sebe.',
        },
        {
          title: 'Tražite drugačiji odnos prema sebi',
          text: 'ne još jedan pokušaj da se popravite.',
        },
        {
          title: 'Želite prostor u kome ne morate odmah da znate',
          text: 'šta dalje.',
        },
        {
          title: 'Osećate da nešto u vama traži oblik',
          text: 'reč, gest, granicu, glas, pravac ili istinitije mesto u vašem životu.',
        },
      ],

      encounterLabel: 'Na pragu',
      encounterTitle1: 'Ne novo ja.',
      encounterTitle2: 'Drugačiji odnos prema istom ja.',
      encounterBlock1Title:
        'Neka iskustva postaju jasnija tek kada postoji dovoljno sigurnosti da ih sretnemo.',
      encounterBlock1Text:
        'Ne samo kroz razgovor, već kroz odnos, akciju, telo, simbol, tišinu i prisustvo druge osobe ili grupe.',
      encounterBlock2Title:
        'Iskustvo ne mora odmah da bude objašnjeno da bi bilo stvarno.',
      encounterBlock2Text:
        'U radu obraćamo pažnju na ono što se formira između impulsa, akcije, unutrašnjeg života, tela, slike i odnosa sa drugima.',
      encounterBlock3Title:
        'Ponekad osoba prvi put primeti sopstvenu istinu tek kada ona dobije prostor, glas, pokret ili oblik.',

      methodLabel: 'Kako radimo u ovom prostoru',
      methodTitle: 'Razgovor, telo, simbol, akcija i tišina.',
      methodIntro:
        'Rad u Tihoj Psihi spaja psihološku refleksiju, iskustvene metode, simboličko istraživanje, telesnu svesnost, pokret, ulogu, grupni proces i pažljivo praćenje onoga što je stvarno prisutno.',

      method1Title: 'Psihologija',
      method1Text:
        'Unutrašnji život ne posmatramo kao problem koji treba brzo rešiti, već kao prostor koji polako može postati čitljiviji.',
      method2Title: 'Akcione metode',
      method2Text:
        'Neka iskustva postaju jasnija tek kada ih vidimo, odigramo, postavimo u prostor ili sretnemo iz druge perspektive.',
      method3Title: 'Telo i pokret',
      method3Text:
        'Telo često registruje istinu, napetost, strah, čežnju i promenu pre nego što ih um ume objasniti.',
      method4Title: 'Simbolički rad',
      method4Text:
        'Slike, uloge, metafore, snovi i unutrašnje scene ponekad nose više informacija od objašnjenja.',
      method5Title: 'Grupni proces',
      method5Text:
        'Odnos sa drugima može postati mesto na kome prvi put primećujemo sopstvene obrasce, impulse, granice i mogućnosti za nešto novo.',

      spacesLabel: 'Staze kroz vrt',
      spacesTitle: 'Različiti načini ulaska u rad.',
      space1Title: 'Individualni susreti',
      space1Text1:
        'Rad jedan na jedan kroz razgovor, simbol, telo i iskustveno istraživanje.',
      space1Text2:
        'Za periode tranzicije, preplavljenosti, unutrašnjih konflikata, odluka, tuge, čežnje ili potrebe za jasnijim kontaktom sa sobom.',
      space2Title: 'Radionice i grupni prostori',
      space2Text:
        'Online i uživo prostori u kojima unutrašnje iskustvo postaje vidljivo kroz susret, akciju, ulogu, grupni proces i simbolički rad.',
      space3Title: 'Praksa tišine',
      space3Text:
        'Istraživanje pažnje, stimulacije, nervnog sistema i odnosa prema unutrašnjem ritmu kroz pisanje, praksu i iskustvene procese.',

      credibility:
        'Master psihologije • 15+ godina iskustva u grupnom radu • psihodramski informisan rad • fizički teatar • Tele\'Drama • međunarodni online i uživo procesi',

      silenceLabel: 'Praksa tišine',
      silenceTitle: 'Tiha staza za pažnju, ritam i nervni sistem.',
      silenceText:
        'Istraživanje tišine, pažnje i pripreme za deset dana tišine u realnom vremenu — kroz beleške, telo i psihološko posmatranje.',
      silenceBlockButton: 'Uđi u praksu',
    },
    about: {
  eyebrow: 'O meni',
  heroTitle: 'Držim prostore u kojima unutrašnji život može da postane vidljiv bez pritiska i sile.',
  heroIntro:
    'Zovem se Tihomira Stanojević. Master sam psihologije, facilitator i praktičarka iskustvenog rada. Tiha Psiha je nastala iz psihologije, grupnog rada, psihodramski informisanih metoda, telesnog i simboličkog istraživanja, zvuka, online prostora i godina učenja o tome kako se čovek pojavljuje istinitije kada više ne mora da bude popravljen.',
  heroIntro2:
    'Radim sa iskustvom onako kako se ono zaista pojavljuje — kroz reči, tišinu, telo, sliku, ulogu, ritam, odnos i male signale koji često dođu pre jasnog objašnjenja.',
  identityLabel: 'Ko drži prostor',
  identityTitle: 'Psiholog, facilitator, praktičarka iskustvenog rada.',
  identityText:
    'Imam master diplomu iz psihologije i više od petnaest godina iskustva u grupnom radu, iskustvenom učenju i akcionim metodama. Moj rad se oblikovao kroz psihodramu, Psychodramatic Bodywork®, fizički teatar, Tele’Dramu, simbolički proces, online facilitaciju i zvučne iskustvene prostore.',
  identityNote:
    'Svoju pozadinu navodim iskreno: psihodrama i srodne iskustvene metode duboko informišu moj rad, ali Tiha Psiha nije predstavljena kao psihoterapija niti kao sertifikovana psihodramska praksa.',
  foundationsLabel: 'Šta oblikuje rad',
  foundationsTitle: 'Prizemljen prostor za iskustvo, simbol i odnos.',
  foundationsIntro:
    'Rad često počinje od reči, ali ne ostaje samo u rečima. Nekad telo zna pre nego što um ume da objasni. Nekad slika, uloga, pokret ili odnos pokažu ono što rečenica još ne može da nosi.',
  foundation1Title: 'Psihologija',
  foundation1Text:
    'Psihologija daje radu stabilan okvir: pažnju prema unutrašnjem životu, obrascima, odnosima, razvoju, granicama, emocijama i složenosti ljudskog iskustva.',
  foundation2Title: 'Grupni proces',
  foundation2Text:
    'Grupa može da pokaže ono što u samoći ostaje skriveno. Kroz svedočenje, rezonancu i susret, osoba često jasnije vidi sopstvene impulse, granice i mogućnosti.',
  foundation3Title: 'Telo, zvuk i simbol',
  foundation3Text:
    'Neka iskustva se ne razjasne samo kroz objašnjenje. Pokret, slika, ritam, zvuk i simbolička akcija mogu da daju oblik onome što je bilo tiho, mutno ili teško imenovati.',
  foundation4Title: 'Prelazi i online prostori',
  foundation4Text:
    'Život u različitim kulturama i rad sa međunarodnim online grupama naučili su me da slušam pripadanje, izmeštenost, tranziciju i suptilne načine na koje ljudi traže sigurnost i prisustvo.',
  trainingLabel: 'Obuka i iskustvo',
  trainingTitle: 'Formalno utemeljenje, jasno navedeno.',
  trainingIntro:
    'Prostor je mekan, ali nije nejasan. Drži ga formalno psihološko obrazovanje, dugogodišnja iskustvena obuka i godine rada sa grupama, online procesima i telesnom praksom.',
  trainingItem1:
    'Osnovne i master studije psihologije na Univerzitetu u Novom Sadu.',
  trainingItem2:
    'Četiri godine treninga klasične psihodrame u Novom Sadu.',
  trainingItem3:
    'Advanced Level Psychodramatic Bodywork® trening proces sa Susan Aaron.',
  trainingItem4:
    'Više ciklusa Fizičkog Teatra sa rediteljkom Marijom Farmer, uključujući devising, Complicité pristup, embodiment i simboličku akciju.',
  trainingItem5:
    'Dodatno učenje kroz Transakcionu analizu, Tele’Drama Practitioner treninge, Ericksonian pristupe, konverzacijsku hipnozu i trening Etika — Put do pravog ja.',
  trainingItem6:
    'Više od petnaest godina rada sa grupama u edukativnim, psihodramskim, kreativnim, ekološkim, online i hibridnim kontekstima.',
  experienceLabel: 'Životno iskustvo',
  experienceTitle: 'Rad se oblikovao kroz pragove.',
  experienceText:
    'Živela sam i radila u različitim kulturnim kontekstima, uključujući Srbiju, Kinu, Ekvador, Indiju, Maltu, Sloveniju, Rusiju i Španiju. Ti prelazi su promenili način na koji razumem tranziciju, pripadanje, identitet, gubitak poznatog okvira i potrebu tela za sigurnošću.',
  experienceText2:
    'Zvuk je ušao postepeno, kroz instrumente sakupljene na različitim mestima i kroz potrebu da se sluša dublje od jezika. Postao je deo načina na koji radim sa pažnjom, ritmom, atmosferom i telesnim prisustvom.',
  storyLabel: 'Kraća priča',
  storyTitle: 'Put nije bio linearan.',
  storyIntro:
    'Duža lična priča pripada drugom prostoru. Ovde ostavljam samo niti koje direktno oblikuju način na koji držim Tihu Psihu.',
  story1Title: 'Slušanje pre govora',
  story1Text:
    'Volontiranje u Centru Srce u Novom Sadu naučilo me je disciplini slušanja pre interpretacije, saveta ili usmeravanja. Oblikovalo je moje poštovanje prema onome što se pojavi kada osoba nije prekinuta.',
  story2Title: 'Online prostor je postao stvaran prostor',
  story2Text:
    'Kroz Tele’Dramu i međunarodne online grupe naučila sam da online rad može da nosi prisustvo, akciju, bliskost i grupni proces kada je struktura jasna, a pažnja stvarna.',
  story3Title: 'Raskršća su postala praksa',
  story3Text:
    'Selidbe, povratci, neizvesnost i ponovno stvaranje naučili su me da tranzicija nije nešto što treba pretrčati. To je prag koji traži pažnju, strpljenje i drugačiji odnos prema sebi.',
  ctaWork: 'Rad sa mnom',
  ctaContact: 'Javi se',
  closingQuote:
    'Ne vodim ljude ka destinacijama. Pomažem im da oslušnu put koji već počinje da se oblikuje.',
  closingButton: 'Istraži načine rada',
},

   work: {
  eyebrow: 'Rad sa mnom',
  title: 'Psihološki utemeljena podrška za periode promene, neizvesnosti i unutrašnjeg procesa.',
  intro:
    'Tiha Psiha je psihološki utemeljena praksa u razvoju, kroz individualne susrete, male iskustvene radionice i zvučna iskustva uživo za ljude koji prolaze kroz promenu, neizvesnost ili unutrašnji proces.',
  intro2:
    'Rad je utemeljen u psihologiji, iskustvenim metodama, simboličkom istraživanju i pažljivom praćenju onoga što je stvarno prisutno sada.',
  heroBadge1: 'Trenutno dostupno',
  heroBadge2: 'Po pozivu',
  heroBadge3: 'U razvoju',

  availableLabel: 'Trenutno dostupno',
  availableTitle: 'Odavde možeš da počneš.',
  availableIntro:
    'Ovo su formati koji su trenutno dostupni online. Jednostavni su, fokusirani i namenjeni ljudima koji žele prizemljen prostor za refleksiju, uvid i unutrašnje orijentisanje.',

  orientationTitle: 'Besplatan uvodni razgovor',
  orientationMeta: '15 minuta · Online',
  orientationText:
    'Kratak razgovor da vidimo šta tražiš, da li je ovaj rad dobar okvir za tebe i koji format bi ti najviše služio.',
  orientationPrice: 'Besplatno',
  orientationCta: 'Zakaži uvodni razgovor',
  orientationMessage:
    'Zanima me besplatan uvodni razgovor. Želim ukratko da podelim šta me dovodi...',

  dreamTitle: 'Vođena sesija istraživanja sna',
  dreamMeta: 'Do 60 minuta · Online',
  dreamText:
    'Vođeni intervju sa snom, simbolom ili unutrašnjom slikom. Ovo nije klasično tumačenje sna. Proces je povezan sa pristupom Josepha Dillarda — Integral Deep Listening / dream interview, za koji sam lično trenirana od Josepha Dillarda. Cilj su praktični uvidi, unutrašnji odgovori i jasnije sagledavanje situacije u kojoj se nalaziš.',
  dreamPrice: '6.000 RSD',
  buyForMyself: 'Kupi za sebe',
  buyAsGift: 'Kupi kao poklon',
  dreamMessage:
    'Zanima me kupovina vođene sesije istraživanja sna za sebe.',
  dreamGiftMessage:
    'Zanima me kupovina vođene sesije istraživanja sna kao poklon.',
      packageTitle: 'Paketi individualne podrške',
      packageMeta: 'Online · Jedan na jedan',
      packageText: 'Individualni susreti za ljude koji prolaze kroz promenu, unutrašnji konflikt, neizvesnost ili potrebu za jasnijim kontaktom sa sobom. Rad može uključivati razgovor, simboličko istraživanje, telesnu svesnost i iskustvenu refleksiju.',
      packagePrice: 'Od 6.000 RSD',
      packageCta: 'Raspitaj se o individualnoj podršci',
      packageMessage: 'Zanima me paket individualne podrške. Želim da podelim kakav proces mi je potreban...',
      pricingLabel: 'Cene',
      pricingTitle: 'Sesije i paketi',
      pricingIntro: 'Paketi su namenjeni refleksivnom i razvojnom radu. Nisu namenjeni hitnim kriznim situacijama.',
      singleSessionTitle: '1 sesija',
      singleSessionPrice: '6.000 RSD',
      singleSessionValidity: 'Jedna sesija važi 3 meseca od datuma kupovine.',
      threeSessionsTitle: '3 sesije',
      threeSessionsPrice: '15.000 RSD',
      threeSessionsValidity: 'Paket od 3 sesije važi 2 meseca od datuma kupovine.',
      fiveSessionsTitle: '5 sesija',
      fiveSessionsPrice: '24.000 RSD',
      fiveSessionsValidity: 'Paket od 5 sesija važi 3 meseca od datuma kupovine.',
      giftSessionTitle: 'Poklon sesija',
      giftSessionPrice: '6.000 RSD',
      giftSessionValidity: 'Poklon sesija važi 3 meseca od datuma kupovine.',
      termsNotice: 'Kupovinom sesije ili paketa prihvatate uslove zakazivanja, pomeranja i otkazivanja.',
      termsLink: 'Pročitaj uslove',
      invitationLabel: 'Po pozivu',
      invitationTitle: 'Radionice, grupni procesi i zvučna iskustva.',
      invitationIntro: 'Neki formati se otvaraju kroz saradnju, poziv ili lokalnu organizaciju. Mogu se oblikovati prema grupi, gradu, zajednici ili određenoj temi.',
      invite1Title: 'Radionice i grupni procesi',
      invite1Text: 'Mali online ili uživo prostori za iskustveno istraživanje kroz susret, akciju, simbol, ulogu, prisustvo grupe i ono što se formira između ljudi.',
      invite2Title: 'Zvučna iskustva uživo',
      invite2Text: 'Zvučni susreti se nude uživo, u zavisnosti od lokacije, saradnje i dostupnog prostora. Nisu performansi, već pažljivo držani iskustveni prostori.',
      invitationCta: 'Pozovi ili organizuj format',
      invitationMessage: 'Zanima me da ugostim ili pozovem radionicu, grupni proces ili zvučno iskustvo. Evo šta imam na umu...',
      developmentLabel: 'U razvoju',
      developmentTitle: 'Ono što se još oblikuje.',
      developmentIntro: 'Tiha Psiha se namerno razvija korak po korak. Neki formati se oblikuju polako i pažljivo, da bi postali jasni, korisni i održivi.',
      development1Title: 'Male kontinuirane grupe',
      development1Text: 'Kontinuirane online grupe mogu se otvoriti kasnije za ljude koji žele kontinuitet, zajedničku refleksiju i iskustveno istraživanje tokom vremena.',
      development2Title: 'Snimljena zvučna iskustva',
      development2Text: 'Snimljeni zvučni materijali su u razvoju kao buduća digitalna ponuda. Biće kreirani pažljivo, uz jasan okvir i jednostavan pristup.',
      questionsTitle: 'Nisi sigurna odakle da počneš?',
      questionsText: 'Ne moraš unapred da znaš tačan format. Kratak uvodni razgovor je često dovoljan da se razjasni sledeći korak.',
      reach: 'Javi se',
      finalMessage: 'Zanima me rad sa tobom, ali još nisam sigurna koji format je najbolji za mene.',
    },
events: {
  label: 'Okupljanja i događaji',
  heroTitle:
    'Prostori u kojima iskustvo postaje vidljivo kroz susret, akciju i grupni rad.',
  heroIntro:
  'Događaji u Tihoj Psihi nisu performansi, predavanja ni brza rešenja. To su prostori za iskustveno istraživanje — kroz odnos, akciju, simbol, ulogu, prisustvo grupe i ono što se formira između ljudi.',  currentTitle: 'Trenutno istraživanje',
  event1Type: 'Online iskustvena radionica',
  event1Title: 'AI & Human Encounter',
  event1RealTitle: 'Kako se zapravo osećam u vezi sa AI-jem?',
  event1Para1:
  'U poslednje vreme sve češće govorimo o veštačkoj inteligenciji — ali ređe govorimo o tome šta se u nama događa dok o njoj razmišljamo.',
  event1Para2:
  'Ova radionica nije o tome šta AI jeste, već šta se u nama pokreće kada se sa njim susretnemo.',
  event1Para3:
  'Da li osećam olakšanje ili pritisak? Da li mi pomaže ili me ubrzava preko mere? Šta se događa sa mojom kreativnošću, načinom rada i osećajem vrednosti?',
  event1Para4:
  'Kroz rad u maloj grupi i uz pomoć psihodramskih i akcionih metoda istraživaćemo unutrašnje reakcije, pitanja i glasove koji se javljaju u susretu sa AI-jem — bez potrebe da zauzmemo „ispravan stav“.',
  eventDateLabel: 'Datum:',
eventDateValue: '04.06.2026, četvrtak',

eventTimeLabel: 'Vreme:',
eventTimeValue: '18:00–21:00',

eventFormatLabel: 'Format:',
eventFormatValue: 'online / Zoom',

eventLanguageLabel: 'Jezik:',
eventLanguageValue: 'srpski / hrvatski',

eventPriceLabel: 'Cena:',
eventPriceValue: '1000 RSD / 10 EUR',

eventGroupLabel: 'Grupa:',
eventGroupValue: 'do 15 učesnika',
  event1Text:
    'Iskustveno istraživanje odnosa između čoveka i veštačke inteligencije kroz psihodramske i akcione metode.',
  event1Button: 'Raspitaj se o radionici',
     inquiryTitle: 'Teme koje istražujem',
  inquiryText:
    'Trenutne teme istraživanja uključuju pažnju, odnos čoveka i AI-a, grupni susret, telo, impuls, preplavljenost, simbolički proces i relacione dinamike.',

  formTitle: 'Prijava',
  formNameLabel: 'Ime i prezime',
  formEmailLabel: 'Email',
  formLocationLabel: 'Odakle se javljate?',
  formMessageLabel: 'Šta vas trenutno najviše zanima u ovoj temi?',
  formNote: 'Nakon prijave dobićete email sa potvrdom mesta i informacijama za uplatu.',
  formButton: 'Pošalji prijavu',
  formSuccessTitle: 'Hvala, prijava je poslata.',
  formSuccessText: 'Javiću vam se uskoro sa potvrdom.',
  eventHiddenValue: 'Kako se zapravo osećam u vezi sa AI-jem? — 04.06.2026',

  upcomingTitle: 'U najavi',
  upcomingType: 'Istraživanje',
  upcomingItems: [
    {
      title: 'Zagrevanje za nove uloge',
      subtitle: 'Kada stari identitet više ne stoji, a novi još nije živ.',
    },
    {
      title: 'Zaglavljeni u promenama',
      subtitle: 'Kad prošlost drži, a budućnost zove.',
    },
    {
      title: 'Ko u nama protestuje',
      subtitle: 'Osvetljavanje unutrašnjeg sabotera.',
    },
  ],

  ongoingGroupsTitle: 'Grupe u toku',
  ongoingGroupsText1:
    'Nedeljni online grupni susreti za ljude koji žele kontinuitet u radu sa sobom i drugima.',
  ongoingGroupsText2:
    'Mali online grupni prostori za kontinuirano iskustveno istraživanje kroz encounter, odnos, akciju i grupnu dinamiku.',

  themesTitle: 'Teme koje istražujem',
  themesText:
    'Trenutne teme istraživanja uključuju pažnju, odnos čoveka i AI-a, grupni susret, telo, impuls, preplavljenost, simbolički proces i relacione dinamike.',
},
    zoom: {
      title: 'Zoom Maestra',
      eyebrow: 'Podrška nevidljivoj strukturi online događaja',
      intro: 'Zoom Maestra podržava strukturu koja stoji iza online događaja, pomažući facilitatorima, edukatorima i terapeutima da svoj rad prenesu sa jasnoćom, stabilnošću i lakoćom.',
      lead1: 'Mnogi ljudi koji vode snažne radionice, kurseve i grupne procese online često se nađu preopterećeni tehničkim delom organizacije.',
      lead2: 'Umesto da budu prisutni sa učesnicima i procesom, oni upravljaju breakout sobama, prijavama, ekranima i neočekivanim tehničkim problemima.',
      lead3: 'Zoom Maestra postoji kako bi facilitator mogao da ostane fokusiran na ljude i proces — dok je struktura događaja stabilno podržana u pozadini.',
      audienceTitle: 'Za koga je ova usluga',
      audienceText: 'Zoom Maestra podržava profesionalce koji rade sa ljudima online i žele stabilnije i mirnije tehničko okruženje.',
      audienceList1: 'facilitatore i vođe grupa',
      audienceList2: 'terapeute i koučeve',
      audienceList3: 'edukatore i autore online kurseva',
      audienceList4: 'organizatore programa koji prelaze u online prostor',
      audienceList5: 'organizacije koje vode online radionice i treninge',
      audienceClosing: 'Ako vaš rad podrazumeva držanje prostora za ljude, tehnološki sloj treba da podržava taj prostor — a ne da ga remeti.',
      supportTitle: 'Kako Zoom Maestra podržava vaš događaj',
      supportIntro: 'Podrška može uključivati:',
      supportBlock1Title: 'Struktura i priprema događaja',
      supportBlock1Item1: 'dizajniranje toka Zoom sesije',
      supportBlock1Item2: 'pripremu breakout soba i grupne dinamike',
      supportBlock1Item3: 'izradu jasnog tehničkog plana događaja',
      supportBlock2Title: 'Prijave i tok učesnika',
      supportBlock2Item1: 'organizaciju sistema prijava',
      supportBlock2Item2: 'pripremu komunikacije sa učesnicima',
      supportBlock2Item3: 'kreiranje jednostavnog ulaska u događaj',
      supportBlock3Title: 'Tehnička podrška tokom događaja',
      supportBlock3Item1: 'tehničko vođenje Zoom prostora',
      supportBlock3Item2: 'upravljanje breakout sobama i prelazima',
      supportBlock3Item3: 'deljenje ekrana i rešavanje tehničkih situacija',
      supportBlock4Title: 'Hibridni i kompleksni događaji',
      supportBlock4Item1: 'podršku događajima koji kombinuju online i fizički prostor',
      supportBlock4Item2: 'koordinaciju između facilitatora i tehničkog sloja događaja',
      supportClosing: 'Cilj je jednostavan: stvoriti stabilnu strukturu u kojoj facilitator može da bude potpuno prisutan sa ljudima i procesom.',
      packagesTitle: 'Načini saradnje',
      package1Title: 'Jedna sesija',
      package1Text: 'Za facilitatore kojima je potrebna mirna tehnička podrška tokom jedne online sesije.',
      package1Item1: 'postavljanje Zoom prostora',
      package1Item2: 'upravljanje breakout sobama',
      package1Item3: 'podrška za deljenje ekrana',
      package1Item4: 'upravljanje ulaskom učesnika i prelazima',
      package1Item5: 'osnovno rešavanje tehničkih situacija tokom događaja',
      package1Ideal: 'Idealno za pojedinačne radionice, grupne susrete, gostujuća predavanja i online časove.',
      package2Title: 'Radionica',
      package2Text: 'Za facilitatore koji vode duže radionice ili programe sa više sesija i žele stabilniju strukturu i iskustvo za učesnike.',
      package2Item1: 'pripremni razgovor pre događaja',
      package2Item2: 'planiranje toka događaja',
      package2Item3: 'tehničku postavku Zoom prostora',
      package2Item4: 'upravljanje ulaskom učesnika',
      package2Item5: 'breakout sobe i prelaze',
      package2Item6: 'tehničko vođenje tokom događaja',
      package2Ideal: 'Idealno za poludnevne i celodnevne radionice, kurseve i programe sa više susreta.',
      package3Title: 'Program',
      package3Text: 'Za kompleksnije online ili hibridne događaje gde facilitator želi stabilnu tehničku strukturu iza procesa.',
      package3Item1: 'planiranje strukture događaja',
      package3Item2: 'podršku oko sistema prijava',
      package3Item3: 'pripremu komunikacije sa učesnicima',
      package3Item4: 'tehničko vođenje Zoom prostora',
      package3Item5: 'koordinaciju breakout soba',
      package3Item6: 'tehničku podršku tokom celog događaja',
      package3Ideal: 'Idealno za online retreat-e, konferencije, duže programe i hibridne događaje.',
      whyTitle: 'Zašto facilitatori rade sa Zoom Maestrom',
      whyIntro: 'Kada facilitatori vode online prostor, njihova pažnja treba da bude usmerena na ljude u prostoru — a ne na tehnologiju.',
      whyIntro2: 'Zoom Maestra podržava tehnički i strukturalni sloj događaja kako bi facilitator mogao da ostane potpuno prisutan u svojoj ulozi.',
      why1Title: 'Veća prisutnost sa učesnicima',
      why1Text: 'Kada je tehnička strana događaja stabilna, facilitator može u potpunosti da se fokusira na ljude — da sluša, vodi i odgovara na proces u realnom vremenu.',
      why2Title: 'Mirniji tok događaja',
      why2Text: 'Online događaji često postaju stresni kada struktura nije jasna. Uz dobru pripremu i tehničku podršku, prelazi postaju jednostavniji, a iskustvo stabilnije za sve učesnike.',
      why3Title: 'Stabilnost i sigurnost',
      why3Text: 'Neočekivane tehničke situacije mogu da poremete atmosferu radionice. Kada neko tiho drži tehnički sloj događaja, cela grupa dobija osećaj stabilnosti.',
      why4Title: 'Više prostora za suštinski rad',
      why4Text: 'Kada facilitator ne mora da upravlja tehničkim detaljima, ima više energije za ono što je najvažnije — proces, dinamiku grupe i transformaciju koja može da se pojavi u prostoru.',
      ctaTitle: 'Treba vam mirna i pouzdana podrška za online događaj?',
      ctaText: 'Ako pripremate online radionicu, kurs, trening ili grupni proces i želite da tehnologija podržava iskustvo umesto da ga remeti, rado ću čuti više o vašem projektu.',
      ctaText2: 'Svaki događaj je drugačiji i zajedno možemo istražiti kakva struktura i podrška bi ga najbolje podržala.',
      ctaButton: 'Piši za Zoom Maestru',
      testimonialsLabel: 'Šta ljudi kažu',
      testimonialsTitle: 'Njihove reči',
      testimonial1Name: 'Diane Adderley',
      testimonial1Text: 'Osećam se sigurno i imam poverenje kada je Tina za tehničkim kormilom naših radionica. Znam da će dobro obaviti posao i ne moram da brinem da će nešto krenuti po zlu. Čak i ako bi se desilo nešto neočekivano, sigurna sam da bi to rešila sa svojom uobičajenom smirenošću. Toplo bih preporučila njene usluge.',
      testimonial1Role:'Počasna predsednica i senior trenerka sociodrame, British Psychodrama Association; gostujuća predavačica, Tele’Drama International.',
      testimonial2Name: 'Marija Babić',
      testimonial2Text:'Sa Tinom sarađujem na različitim projektima već dugo. Svaki put kada znam da ona brine o prostoru i tehničkim detaljima na Zoom platformi, nemam ni najmanju brigu ni sumnju oko toga kako će se događaj odvijati i završiti.',
      testimonial2Role:'PermaVEZ kolektiv',
      testimonial3Name: 'Lou Van Laake',
      testimonial3Text:'Tina mi je kao tehnička podrška omogućila da se u potpunosti fokusiram na svoj zadatak domaćina i facilitatorke. Njeno mirno i sposobno prisustvo iza scene skinulo je sa mene dodatni sloj odgovornosti i stresa, i pomoglo mi da ostanem potpuno prisutna sa ljudima na ekranu. Sećam se da sam se i sama osećala smirenije, da sam mogla lakše da dišem i da sam imala više prostora u glavi za sve što se pojavljivalo tokom samog susreta. Posebno za kreativni online rad, kao što su Playback Theatre ili psihodrama, toplo bih preporučila Tinu. Ona razume ove umetničke forme na ovoj još uvek novoj online platformi — zna koji su pravi trenuci za spotlight, mute ili pomeranje ljudi da „sednu” pored facilitatora. Tina donosi znanje, kreativnost, radoznalost i mirnu spremnost da popravi, objasni i podrži ljude sa kojima radi. Tiho je prisutna, ali nezamenljiva. Takođe je jasna u postavljanju pitanja i davanju povratnih informacija, i jednostavno je san za saradnju.',
      testimonial3Role:'Playback Theatre facilitatorka, praktičarka fizičkog teatra i voditeljka Full Circle Playback Theatre, Dablin, Irska.',
      testimonial4Name: 'Dr. Ron Wiener',
      testimonial4Text:'Tina Stanojević je bila odlična tehnička podrška na sociodramskoj radionici koju sam nedavno ko-facilitirao na Zoomu. Učestvovala je u planiranju i dala korisne predloge i pre i tokom radionice. Tokom same sesije koristila je svoje tehničke veštine da obezbedi da sve teče glatko, uključujući i podešavanje sata za pauze, što je omogućilo da se svi vrate na vreme.',
      testimonial4Role:'Senior trener sociodrame.',
      ctaSubject: 'Upit za Zoom Maestru',
    },
    contact: {
      title: 'Kontakt',
      intro: 'Bilo da vas zanimaju individualne sesije, grupni rad ili samo želite da istražite šta je moguće, tu sam da saslušam i podržim vaš put.',
      email: 'Email',
      follow: 'Pratite',
      response: 'Na upite obično odgovaram u roku od 2–3 dana. Hvala vam što ste se javili.',
      yourName: 'Vaše ime',
      namePlaceholder: 'Vaše ime',
      emailLabel: 'Email',
      emailPlaceholder: 'vas@email.com',
      message: 'Poruka',
      messagePlaceholder: 'Recite mi šta vas dovodi ovde...',
      send: 'Pošalji poruku',
      successMessage: '✓ Poruka je poslata!',
      errorMessage: 'Greška. Pokušajte ponovo ili pišite direktno na email.',
      sending: 'Šalje se...',
      formSubject: 'Poruka od',
      formName: 'Ime',
      formEmail: 'Email',
      contactFlowTitle: 'Kako mogu da te podržim?',
      contactFlowIntro: 'Izaberi pravac koji najviše odgovara onome što tražiš.',
      path1Title: 'Individualni rad',
      path1Text: 'Za ljude koji traže podršku kroz rad jedan na jedan.',
      path1Button: '1 na 1',
      path1Subject: 'Upit za individualni rad',
      path2Title: 'Radionice i grupni procesi',
      path2Text: 'Za organizatore, zajednice, timove i grupne saradnje.',
      path2Button: 'Radionice',
      path2Subject: 'Upit za radionicu ili grupni proces',
      path3Title: 'Zvučna iskustva uživo',
      path3Text: 'Za joga studije, retreat prostore, male grupe i organizatore koji žele pažljivo držan zvučni prostor.',
      path3Button: 'Raspitaj se za zvučno iskustvo',
      path3Subject: 'Upit za zvučno iskustvo',
      path3LearnMore: 'Saznaj više',
      path1Message:'Zanima me individualni rad. Želim da podelim ukratko šta me dovodi...',
      path2Message:'Zanima me radionica, grupni proces ili zvučna kupka. Evo šta imam na umu...',
      path3Message: 'Zanima me zvučno iskustvo / sound bath. Želim da podelim gde bi se održalo, za koliko ljudi i kakav prostor imam na umu...',
    },
    footer: {
      brand: 'Tiha Psiha',
      tagline: 'Psihologija, embodiment i iskustveni prostori za ljude u tranziciji.',
      credentials: 'Master psihologije • psihodrama • embodiment • međunarodni online i uživo rad',
      zoomText: 'Podrška za online grupne prostore, radionice i fasilitatore.',
      copyright: 'Sva prava zadržana.',
      desc: 'Transformativna facilitacija i psihologija',
      rights: '© 2024 Tihomira Stanojević. Sva prava zadržana.',
    },
  },
};

export default translations;
